import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { darkColors } from '@tryhackme/thm-ui-components';

export const StyledAccordionWrapper = styled.div<{ $isExpanded: boolean; $isTaskBreakdownSupported: boolean }>`
  background-color: ${darkColors.background.dark};
  color: rgba(249, 249, 251, 1);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: ${({ $isExpanded }) => ($isExpanded ? '3rem' : '2.2rem')};
  position: sticky;
  top: ${({ $isTaskBreakdownSupported }) => ($isTaskBreakdownSupported ? 0 : '1.6rem')};
  z-index: 3;
  border: 1px solid rgba(62, 71, 90, 1);
`;

export const StyledAccordionSummary = styled.div<{ $isWide: boolean }>`
  display: flex;
  gap: 1rem;
  background: rgba(28, 37, 56, 1);
  align-items: center;
  min-height: 5.4rem;
  padding: ${({ $isWide }) => ($isWide ? '1.2rem 1.6rem' : '1.2rem')};
`;

export const StyledAccordionSummaryIpTagsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-grow: 0;
  flex-wrap: wrap;
`;

export const StyledAccordionSummaryLeftSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
  gap: 1rem;
`;

export const StyledAccordionContent = styled.div<{ $isExpanded: boolean; $isWide: boolean }>`
  display: flex;
  gap: 3rem;
  background: linear-gradient(179.2deg, #223654 72.84%, #182337 145.61%, #151c2b 188.82%);
  flex: 1;
  padding: 2.4rem ${({ $isWide }) => ($isWide ? '3rem' : '1.8rem')};
  border-top: 1px solid rgba(62, 71, 90, 1);
`;

export const StyledAccordionContentWrapper = styled.div<{ $isExpanded: boolean }>`
  max-height: ${({ $isExpanded }) => ($isExpanded ? '100rem' : '0')};
  transition: max-height 600ms ease;
`;

export const StyledMachinesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
`;

export const StyledImage = styled.img<{ $isWide: boolean }>`
  display: ${({ $isWide }) => ($isWide ? 'inline-block' : 'none')};
`;

export const StyledAccordionSummaryIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.primary.main};
  margin-right: 0.6rem;
`;

export const StyledExpandIcon = styled(FontAwesomeIcon)`
  width: 1.8rem;
  height: 2.4rem;
  cursor: pointer;
`;

export const StyledAccordionSummaryRightSection = styled.span`
  align-self: flex-start;
`;
